import moment from 'moment';
import { isProduction } from 'constants/';

/**
 * Remove Referral cookie middleware
 *
 * Takes in a request and removes the Referral cookie
 */
export const removeReferral = () => {
    return (req, res, next) => {
        // remove the Referral cookie from all requests
        let cookies = res.get('set-cookie');

        if (cookies) {
            // make sure cookies is an array
            if (typeof cookies === 'string') {
                cookies = [cookies];
            }

            cookies = cookies.filter(cookie => (/^Referral.+/).test(cookie) === false);

            res.set('set-cookie', cookies);
        }

        next();
    };
};

/**
 * Get the values from the referral cookie
 *
 * @param  {String} cookie
 *
 * @return {Object}
 */
export const getReferralCookieValues = cookie => {
    const pairs = {};

    if (!cookie) {
        return pairs;
    }

    const cookieValuePairs = cookie.match(/Referral=(.+?);/);

    if (cookieValuePairs && cookieValuePairs[1]) {
        cookieValuePairs[1].split('&').forEach(pair => {
            const splitPair = pair.split('=');

            if (splitPair[0]) {
                pairs[splitPair[0]] = splitPair[1];
            }
        });
    }

    return pairs;
};

/**
 * Takes in a response and modifies the Referral cookie to the correct CLICKID
 *
 * @param {object} req The request object from express
 * @param {object} res The response object from express
 */
export const setReferralClickid = (req, res) => {
    const entryTime = moment();

    let cookies = res.get('set-cookie');

    if (cookies) {
        let referralString = '';
        let refid = '';

        // make sure cookies is an array
        if (typeof cookies === 'string') {
            cookies = [cookies];
        }

        // filter out the Referral cookie
        cookies = cookies.filter(cookie => {
            // if Referral cookie, pull out it's values
            if ((/^Referral.+/).test(cookie)) {
                const values = getReferralCookieValues(cookie);

                // create the refid from SOURCEID+ID
                refid = values.SOURCEID + values.ID;

                values.CLICKID = (/^[\w-:|%]+$/).test(req.query.refclickid) ? req.query.refclickid : 'PPNSEO';

                referralString = Object.keys(values)
                    .map(key => `${key}=${values[key]}`)
                    .join('&');
            }

            // pass through other cookies
            return (/^Referral.+/).test(cookie) === false;
        });

        // re-set cookies without the Referral cookie
        res.set('set-cookie', cookies);

        // shared cookie options
        const options = {
            domain: isProduction ? '.priceline.com' : '.app.localhost',
            path: '/',
            httpOnly: true,
            secure: true,
            expires: new Date(entryTime.utc() + 28 * 24 * 60 * 60 * 1000),
            encode: String
        };

        // set new Referral cookie with new values
        if (referralString) {
            res.cookie('Referral', referralString, options);
        }

        // set a refid cookie that we can grab from js
        if (refid) {
            res.cookie('SEO_REFID', refid, {
                ...options,
                httpOnly: false
            });
        }
    }
};
